import { useL10n } from '@uplift/hooks';
import { useFormikContext } from 'formik';
import { InsuranceFormType } from '../hooks/use-insurance-form.hook';
import { YesNoRadioButtonGroup } from '../../../Inputs';
import { useInsuranceCompaniesQuery, useUserProfileQuery, useUserQuery } from '@uplift/queries';
import { useCurrentuser } from '@uplift/contexts';

export type IsPrimaryInsuranceFormProps = {
  patientId: string;
};

export const IsPrimaryInsuranceForm: React.VFC<IsPrimaryInsuranceFormProps> = ({ patientId }) => {
  const { data: insuranceCompanies } = useInsuranceCompaniesQuery();
  const formik = useFormikContext<InsuranceFormType>();
  const l10n = useL10n();
  const me = useCurrentuser();
  const { data: patient } = useUserQuery(patientId);
  const { data: profile } = useUserProfileQuery(patientId);


  const currentInsuranceId = formik.values.insuranceProvider;
  const currentInsurance = insuranceCompanies?.find((insuranceCompany) => insuranceCompany.id === currentInsuranceId);
  const insuranceName = currentInsurance?.name ?? 'this insurance';

  let label;

  if (me.role === 'patient') {
    label = l10n.accountSettings.insurance.isPrimaryInsurance(insuranceName);
  } else if (me.role === 'superadmin') {
    label = l10n.accountSettings.insurance.adminIsPrimaryInsurance(insuranceName, (profile?.preferredName || patient?.firstName) ?? '');
  }

  return (
    <div>
      <YesNoRadioButtonGroup
        name="isPrimaryInsurance"
        label={label}
      />
    </div>
  );
};
